import React, { createContext, useContext, useState } from 'react';

const TimesheetDateContext = createContext();

export const TimesheetDateProvider = ({ children }) => {
  const [ApprTsStartDate, ApprTsSetStartDate] = useState(null);
  const [ApprTsEndDate, ApprTsSetEndDate] = useState(null);
  const [ApprTsHasFetched, ApprTsSetHasFetched] = useState(null);

  return (
    <TimesheetDateContext.Provider 
      value={{
        ApprTsStartDate, 
        ApprTsSetStartDate, 
        ApprTsEndDate, 
        ApprTsSetEndDate,
        ApprTsHasFetched, 
        ApprTsSetHasFetched,
        }}>
      {children}
    </TimesheetDateContext.Provider>
  );
};

export const useTimesheetDate = () => {
  const ctx = useContext(TimesheetDateContext);
  if (!ctx) {
    return {
      ApprTsStartDate: null,
      ApprTsSetStartDate: () => {},
      ApprTsEndDate: null,
      ApprTsSetEndDate: () => {},
      ApprTsHasFetched: null, 
      ApprTsSetHasFetched: () => {},
    };
  }
  return ctx;
};

const ExpenseSheetDateContext = createContext();

export const ExpenseSheetDateProvider = ({ children }) => {
  const [ApprExpStartDate, ApprExpSetStartDate] = useState(null);
  const [ApprExpEndDate, ApprExpSetEndDate] = useState(null);
  const [ApprExpHasFetched, ApprExpSetHasFetched] = useState(null);

  return (
    <ExpenseSheetDateContext.Provider 
      value={{
        ApprExpStartDate, 
        ApprExpSetStartDate, 
        ApprExpEndDate, 
        ApprExpSetEndDate,
        ApprExpHasFetched, 
        ApprExpSetHasFetched,
        }}>
      {children}
    </ExpenseSheetDateContext.Provider>
  );
};

export const useExpenseSheetDate = () => {
  const ctx = useContext(ExpenseSheetDateContext);
  if (!ctx) {
    return {
      ApprExpStartDate: null,
      ApprExpSetStartDate: () => {},
      ApprExpEndDate: null,
      ApprExpSetEndDate: () => {},
      ApprExpHasFetched: null, 
      ApprExpSetHasFetched: () => {},
    };
  }
  return ctx;
};